
import { Vue, Component, Prop, Emit } from 'vue-property-decorator';
import Tooltip from '@/components/common/Tooltip.vue';
import TooltipVariants from '@/entities/TooltipVariants';
import TableInfo from '@/components/icons/TableInfo.vue';

@Component({
	components: {
		Tooltip,
		TableInfo,
	},
})
export default class DataTable extends Vue {
	@Prop({ default: () => [] }) readonly columns!: any[];
	@Prop({ required: true }) readonly data!: any[];
	@Prop({ default: () => [] }) readonly selectedRows!: number[];
	@Prop({ default: false }) readonly hasActions!: boolean;
	TooltipVariants = TooltipVariants;
		@Prop({ default: null }) readonly sort_by!: string;
	@Prop({ default: null }) readonly sort_direction!: string;


		sortColumn(field: string) {
		if (this.sort_direction === 'desc') {
			this.$emit('sort', {});
		} else {
			const newOrder: string =
				this.sort_by === field && this.sort_direction === 'asc'
					? 'desc'
					: 'asc';
			this.$emit('sort', { sortBy: field, sortDirection: newOrder });
		}
	}
	get areAllSelected(): boolean {
		return (
			this.data.length &&
			this.data.every((row) => this.selectedRows.includes(row.id))
		);
	}
	@Emit('update:selectedRows')
	updateSelectedRows(selectedRows: number[]) {
		return selectedRows;
	}
	toggleSelection(rowId: number) {
		const newSelectedRows = this.selectedRows.includes(rowId)
			? this.selectedRows.filter((id) => id !== rowId) // remove the id
			: [...this.selectedRows, rowId]; // add the id

		this.updateSelectedRows(newSelectedRows);
	}
	selectAllRows(event: Event) {
		const target = event.target as HTMLInputElement;
		const newSelectedRows = target.checked
			? this.data.map((row) => row.id)
			: [];
		this.updateSelectedRows(newSelectedRows);
	}
  // This JavaScript code adds the 'safari' class to the body element when the browser is Safari.
  isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  if (isSafari) {
    document.body.classList.add('safari');
  }
}
